import React, { useState } from 'react';
import { FaUserFriends, FaGraduationCap, FaCalendarAlt, FaSearch, FaUserPlus, FaStar } from 'react-icons/fa';

const LearningNetwork = () => {
  const [experts, setExperts] = useState([
    {
      id: 1,
      name: 'Maria Rodriguez',
      expertise: ['Organic Millet', 'Sustainable Irrigation'],
      location: 'Village A',
      rating: 4.8,
      availability: 'Available',
      experience: '15 years',
      matches: 5
    },
    {
      id: 2,
      name: 'John Smith',
      expertise: ['Crop Rotation', 'Soil Health'],
      location: 'Village B',
      rating: 4.6,
      availability: 'Busy until May 20',
      experience: '12 years',
      matches: 3
    },
    {
      id: 3,
      name: 'Aisha Patel',
      expertise: ['Pest Management', 'Organic Certification'],
      location: 'Village C',
      rating: 4.9,
      availability: 'Available',
      experience: '20 years',
      matches: 7
    }
  ]);

  const [noviceFarmers, setNoviceFarmers] = useState([
    {
      id: 1,
      name: 'Carlos Mendez',
      interests: ['Transitioning to Organic', 'Water Conservation'],
      location: 'Village D',
      farmSize: '5 acres',
      currentCrops: ['Corn', 'Beans']
    },
    {
      id: 2,
      name: 'Sarah Johnson',
      interests: ['Sustainable Practices', 'Crop Diversification'],
      location: 'Village E',
      farmSize: '8 acres',
      currentCrops: ['Wheat']
    },
    {
      id: 3,
      name: 'Ahmed Hassan',
      interests: ['Organic Certification', 'Soil Improvement'],
      location: 'Village F',
      farmSize: '3 acres',
      currentCrops: ['Vegetables']
    },
    {
      id: 4,
      name: 'Lisa Chen',
      interests: ['Pest Management', 'Irrigation Techniques'],
      location: 'Village A',
      farmSize: '6 acres',
      currentCrops: ['Rice']
    },
    {
      id: 5,
      name: 'Miguel Fernandez',
      interests: ['Organic Millet', 'Sustainable Practices'],
      location: 'Village B',
      farmSize: '4 acres',
      currentCrops: ['Corn']
    }
  ]);

  const [matches, setMatches] = useState([
    {
      id: 1,
      expert: 'Maria Rodriguez',
      novices: ['Miguel Fernandez', 'Sarah Johnson'],
      focus: 'Organic Millet Transition',
      status: 'Active',
      startDate: 'April 15, 2023'
    },
    {
      id: 2,
      expert: 'Aisha Patel',
      novices: ['Lisa Chen', 'Ahmed Hassan', 'Carlos Mendez'],
      focus: 'Pest Management Strategies',
      status: 'Scheduled',
      startDate: 'May 25, 2023'
    }
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [filterExpertise, setFilterExpertise] = useState('');

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleFilterExpertise = (e) => {
    setFilterExpertise(e.target.value);
  };

  const filteredExperts = experts.filter(expert => {
    const matchesSearch = expert.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         expert.location.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesExpertise = filterExpertise === '' || 
                            expert.expertise.some(e => e.toLowerCase().includes(filterExpertise.toLowerCase()));
    
    return matchesSearch && matchesExpertise;
  });

  const handleCreateMatch = () => {
    // In a real app, this would open a matching form
    alert('Creating new expert-novice match');
  };

  return (
    <div className="learning-network">
      <div className="section-header">
        <h2>Community Learning Network</h2>
      </div>
      
      <div className="network-container">
        <div className="network-sidebar">
          <div className="search-section">
            <h3>Find Experts</h3>
            <div className="search-box">
              <FaSearch className="search-icon" />
              <input 
                type="text" 
                placeholder="Search by name or location" 
                value={searchTerm}
                onChange={handleSearch}
              />
            </div>
            <div className="filter-box">
              <select 
                value={filterExpertise}
                onChange={handleFilterExpertise}
              >
                <option value="">All Expertise Areas</option>
                <option value="Organic">Organic Farming</option>
                <option value="Irrigation">Irrigation</option>
                <option value="Soil">Soil Management</option>
                <option value="Pest">Pest Control</option>
                <option value="Crop">Crop Rotation</option>
              </select>
            </div>
          </div>
          
          <div className="expert-list">
            {filteredExperts.map(expert => (
              <div key={expert.id} className="expert-card">
                <div className="expert-header">
                  <h4>{expert.name}</h4>
                  <div className="expert-rating">
                    <FaStar /> {expert.rating}
                  </div>
                </div>
                <div className="expert-details">
                  <div className="expert-location">{expert.location}</div>
                  <div className="expert-experience">{expert.experience} experience</div>
                  <div className="expert-expertise">
                    {expert.expertise.map((skill, index) => (
                      <span key={index} className="expertise-tag">{skill}</span>
                    ))}
                  </div>
                  <div className="expert-availability">{expert.availability}</div>
                </div>
                <div className="expert-matches">
                  <FaUserFriends /> {expert.matches} active matches
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="network-main">
          <div className="matches-section">
            <div className="matches-header">
              <h3>AI Matchmaker</h3>
              <button className="create-match-button" onClick={handleCreateMatch}>
                <FaUserPlus /> Create Match
              </button>
            </div>
            
            <div className="matches-list">
              {matches.map(match => (
                <div key={match.id} className="match-card">
                  <div className="match-header">
                    <h4>{match.focus}</h4>
                    <div className={`match-status ${match.status.toLowerCase()}`}>
                      {match.status}
                    </div>
                  </div>
                  
                  <div className="match-details">
                    <div className="match-expert">
                      <strong>Expert:</strong> {match.expert}
                    </div>
                    <div className="match-novices">
                      <strong>Novice Farmers:</strong> 
                      <div className="novice-list">
                        {match.novices.map((novice, index) => (
                          <span key={index} className="novice-name">{novice}</span>
                        ))}
                      </div>
                    </div>
                    <div className="match-date">
                      <FaCalendarAlt /> Start Date: {match.startDate}
                    </div>
                  </div>
                  
                  <div className="match-actions">
                    <button className="view-details-button">View Details</button>
                    <button className="schedule-button">
                      <FaCalendarAlt /> Schedule Session
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="learning-resources">
            <h3>Upcoming Learning Events</h3>
            <div className="events-list">
              <div className="event-card">
                <div className="event-date">May 20, 2023</div>
                <div className="event-details">
                  <h4>Organic Certification Workshop</h4>
                  <div className="event-location">Community Center, Village A</div>
                  <div className="event-host">Hosted by: Aisha Patel</div>
                </div>
                <button className="register-button">Register</button>
              </div>
              
              <div className="event-card">
                <div className="event-date">June 5, 2023</div>
                <div className="event-details">
                  <h4>Sustainable Irrigation Field Day</h4>
                  <div className="event-location">Demonstration Farm, Village C</div>
                  <div className="event-host">Hosted by: Maria Rodriguez</div>
                </div>
                <button className="register-button">Register</button>
              </div>
              
              <div className="event-card">
                <div className="event-date">June 15, 2023</div>
                <div className="event-details">
                  <h4>Crop Rotation Planning Session</h4>
                  <div className="event-location">Online Webinar</div>
                  <div className="event-host">Hosted by: John Smith</div>
                </div>
                <button className="register-button">Register</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearningNetwork; 